module.exports = __webpack_public_path__ + "img/iceland.dc313c31.png";